module.exports = __webpack_public_path__ + "img/logo.0ad15ca6.png";